// src/pages/MyAccount.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";

export default function MyAccount() {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>You must be logged in to view this page.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8">
      <h1 className="text-2xl font-bold mb-4">My Account</h1>
      <p>Email: {user.email}</p>
      {/* Tu peux ajouter d'autres infos ou liens ici */}
    </div>
  );
}
